import { RadioGroup, Text } from "@overmap-ai/blocks"
import { cx } from "class-variance-authority"
import { Dot } from "lucide-react"
import { type ComponentProps, memo } from "react"

import { PROCEDURE_STEP_FIELD_VALUES_REVIEW_TYPES } from "../../constants"
import { procedureStepFieldValuesReviewTypeData } from "../../mappings/procedures"

interface ProcedureStepFieldValuesReviewTypeRadioGroupProps extends Omit<
	ComponentProps<typeof RadioGroup.Root>,
	"children"
> {}

export const ProcedureStepFieldValuesReviewTypeRadioGroup = memo<ProcedureStepFieldValuesReviewTypeRadioGroupProps>(
	(props) => {
		const { ref, className, ...rest } = props

		return (
			<RadioGroup.Root ref={ref} className={cx("flex flex-col gap-2", className)} {...rest}>
				{PROCEDURE_STEP_FIELD_VALUES_REVIEW_TYPES.map((reviewType) => {
					const { label, description } = procedureStepFieldValuesReviewTypeData[reviewType]

					return (
						<div key={reviewType} className="flex items-center gap-2">
							<RadioGroup.Item
								// @ts-expect-error REASON: enum
								value={reviewType}
							>
								<RadioGroup.Indicator>
									<Dot />
								</RadioGroup.Indicator>
							</RadioGroup.Item>
							<div className="flex flex-col">
								<Text size="sm">{label}</Text>
								<Text size="xs" accentColor="base">
									{description}
								</Text>
							</div>
						</div>
					)
				})}
			</RadioGroup.Root>
		)
	},
)
ProcedureStepFieldValuesReviewTypeRadioGroup.displayName = "ProcedureStepFieldValuesReviewTypeRadioGroup"
